import { Box, Theme, Typography } from "@outschool/backpack";
import { Search as SearchFilters } from "@outschool/business-rules";
import { TFunction } from "@outschool/localization";
import { useTrackEvent } from "@outschool/ui-analytics";
import {
  ToggleButton,
  TrackingPageSection,
} from "@outschool/ui-legacy-component-library";
import React from "react";

import { CategoryTutoringFiltersProps } from "./HeroFilters";

function dayString(day: string, t: TFunction) {
  switch (day) {
    case "Sun":
      return t("Sunday");
    case "Mon":
      return t("Monday");
    case "Tue":
      return t("Tuesday");
    case "Wed":
      return t("Wednesday");
    case "Thu":
      return t("Thursday");
    case "Fri":
      return t("Friday");
    case "Sat":
      return t("Saturday");
    default:
      return t("");
  }
}

function selectedDays(days: string) {
  return days?.split(",");
}

const TutoringCLPdowFilter: React.FC<CategoryTutoringFiltersProps> = ({
  categorySlug,
  updateListings,
  label,
  t,
  searchFilters,
}) => {
  const trackEvent = useTrackEvent();
  return (
    <TrackingPageSection name="category_dow_filters" uniqueId={"radio_buttons"}>
      {setImpressionNode => (
        <Box
          flex
          sx={{
            flexWrap: "wrap",
            gap: "10px",
          }}
          ref={setImpressionNode}
        >
          <Typography
            variant="h4"
            emphasized
            sx={(theme: Theme) => ({
              width: "100%",
              padding: "12px",
              [theme.breakpoints.up("md")]: {
                borderBottom: "1px solid",
                borderColor: theme.palette.grey[300],
              },
              [theme.breakpoints.down("md")]: {
                textAlign: "center",
              },
            })}
          >
            {label}
          </Typography>
          <Box
            flex
            sx={(theme: Theme) => ({
              flexWrap: "wrap",
              gap: "12px",

              [theme.breakpoints.down("md")]: {
                justifyContent: "center",
              },
            })}
          >
            {SearchFilters.DAYS_OF_WEEK.map(day => {
              const enabled = selectedDays(searchFilters.dow)?.includes(day);
              return (
                <ToggleButton
                  key={day}
                  enabled={enabled}
                  onClick={() => {
                    updateListings(day);
                    trackEvent("category_filter_click", {
                      categorySlug,
                      searchFilters: day,
                    });
                  }}
                  sx={{
                    marginRight: "tiny",
                    width: "113px",
                    color: enabled ? "white" : "primary",
                    borderColor: "primary",
                    borderWidth: "2px",
                  }}
                  value={day}
                >
                  {dayString(day, t)}
                </ToggleButton>
              );
            })}
          </Box>
        </Box>
      )}
    </TrackingPageSection>
  );
};

export default TutoringCLPdowFilter;
